import elementIntersectionObserver from '../../../dom/elementintersectionobserver';

export function lazybvshow() {
    const MIN_HEIGHT = 640,
        rootMarginThreshold = window.innerHeight < MIN_HEIGHT ? MIN_HEIGHT : window.innerHeight * .66, 
        observe = elementIntersectionObserver({
            rootMargin: `${rootMarginThreshold}px`
        }),
        $$bvShow = document.querySelectorAll('[data-lazy-bv-show]');

    [...$$bvShow].forEach($bvShow =>
        observe($bvShow, $element => ($element.dataset.bvShow = $element.dataset.lazyBvShow))
    );
}

export function initializeBVReviewClick(element){
    if(!element){
        throw new Error('initializeBVReviewClick requires valid element');
    }
    element.addEventListener('mouseover', function bvEvent() {
        element.removeEventListener('mouseover', bvEvent);
        Array.from(document.querySelectorAll('[data-lazy-bv-show]:not(.reviewStars)')).forEach(el => el.dataset.bvShow = el.dataset.lazyBvShow);
    });
}